module.exports = __webpack_public_path__ + "img/9.fba2930a.jpg";